import { colors, styled } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import Select, { SelectProps as MuiSelectProps } from '@mui/material/Select';
import { AiFillMinusCircle } from 'react-icons/ai';

export type SelectProps = {
    label?: string,
    errorText?: string | false,
    collapse?: boolean,
} & MuiSelectProps;

const StyledTextFieldContainer = styled('div')(() => ({
    display: 'flex',
    fontFamily: 'Roboto',
    flexDirection: 'column',
    width: '100%',
    input: { padding: '0 !important' },
    '.MuiOutlinedInput-root': {
        borderRadius: 'unset',
        'minHeight': '40px',
    }
}));

const StyledInfosContainer = styled('div')({
    'marginBottom': '6px',
    display: 'flex',
    fontFamily: 'Roboto',
    flexDirection: 'column'
});

const StyledErrorContainer = styled('span')({
    'fontSize': "13px",
    'color': "#D82829",
    'lineHeight': "18px",
    'fontWeight': 400,
    'fontFamily': "Roboto !important",
    'display': 'flex',
    'alignItems': 'center',
    'textAlign': "left"
});

const StyledLabelContainer = styled('span')(({ disabled, readOnly }: Partial<MuiSelectProps>) => ({
    fontSize: "14px",
    color: readOnly ? "black" : disabled ? "#9DA6AD" : "#152935",
    letterSpacing: "0",
    'lineHeight': "14px",
    fontFamily: "Roboto !important",
    fontWeight: 700,
    textAlign: "left",
    borderRadius: 'unset',
    display: 'flex',
    alignItems: 'center',
    'marginBottom': '0px',
    'marginLeft': 2
}));

const StyledSelect = styled(Select)(({ disabled, readOnly, error, multiple }: Partial<MuiSelectProps>) => ({
    border: disabled ? '1px solid #C1C1C4' : readOnly ? '1px solid #C1C1C4' : error ? '1px solid #D82829' : '1px solid #C9D9E8',
    backgroundColor: (disabled || readOnly) ? '#FAFBFD' : '#F2F5F8',
    font: 'unset',
    fontFamily: 'Roboto',
    borderRadius: 'unset',
    cursor: disabled ? 'not-allowed!important' : 'pointer!important',
    '& .MuiBox-root': {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    '*': {
        cursor: disabled ? 'not-allowed!important' : 'pointer!important'
    },
    ':hover': {
        border: disabled ? '1px solid #0090D1' : readOnly ? '1px solid #C1C1C4' : error ? '1px solid #D82829' : '1px solid #0090D1!important'
    },
    '::placeholder': {
        fontSize: "14px!important",
        color: (disabled || readOnly) ? "#C1C1C4" : "#9DA6AD",
        lineHeight: "18px",
        fontFamily: "Roboto",
        fontWeight: 400,
        textAlign: "left"
    },
    '::before': {
        all: 'unset'
    },
    '::after': {
        all: 'unset'
    },
    '.MuiSelect-select': {
        padding: multiple ? '6px 14px' : '7.5px 14px'
    },
    '.MuiNativeSelect-select': {
        padding: multiple ? '6px 14px' : '7.5px 14px'
    },
    'input': { display: 'none' },
    'fieldset': { display: 'none' },
}));

export const VdsSelect = (props: SelectProps) => {

    const { label, errorText, collapse, children, ...MuiSelectProps } = props;

    return (
        <StyledTextFieldContainer sx={{
            //'minHeight': collapse ? 'unset' : '96px',
            'minHeight': collapse ? 'unset' : '81px',
            width: '100%'
        }}>
            {label && <StyledInfosContainer>
                <StyledLabelContainer>
                    {label}
                </StyledLabelContainer>
            </StyledInfosContainer>}
            <FormControl size="small">
                <StyledSelect {...MuiSelectProps}>
                    {children}
                </StyledSelect>
            </FormControl>
            {props.error && props.errorText && (
                <StyledErrorContainer>
                    <AiFillMinusCircle size={13} style={{ marginLeft: 6, marginRight: 6 }} /> {errorText}
                </StyledErrorContainer>
            )}
        </StyledTextFieldContainer>
    );
}
